import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import reduce from 'lodash/reduce';

import style from '@core/Page/LeftMenu/UserProfile/UserProfile.module.scss';

import { AvatarUnits } from 'chaika-frontend-types/frontend-cms';

import { ClickOutsideAlerter } from '@components/ClickOutsideAlerter';
import { Avatar } from '@components/Avatar';

import { OrganizationSelect } from '@core/Page/LeftMenu/UserProfile/OrganizationSelect';

export interface UserProfileProps {
    isOpen: boolean;
}

interface Props extends UserProfileProps {
    firstName: string;
    lastName: string;
    avatar?: string;
    avatarUnits?: AvatarUnits;
    hasOrganizations: boolean;
    organization: string;
    abbreviation: string;
    selectOrganizationOpen: boolean;
    onOrganizationClick(): void;
    onOrganizationSelect(organizationId?: string): void;
}

export function UserProfile({
    isOpen,
    firstName,
    lastName,
    avatar,
    avatarUnits,
    organization,
    abbreviation,
    hasOrganizations,
    selectOrganizationOpen,
    onOrganizationClick,
    onOrganizationSelect,
}: Props) {
    return (
        <div className={classnames([style.root, isOpen && style.root_open])}>
            {selectOrganizationOpen && (
                <ClickOutsideAlerter onClickOutside={onOrganizationSelect}>
                    <div className={style.organizationSelect}>
                        <OrganizationSelect onSelect={onOrganizationSelect} />
                    </div>
                </ClickOutsideAlerter>
            )}
            <div className={style.profileLink}>
                <NavLink
                    to={'/profile'}
                    className={style.profileIcon}
                    draggable={false}
                >
                    <Avatar
                        url={avatar}
                        avatarUnits={avatarUnits}
                        key={reduce(avatarUnits, (r, v) => r + v, 0)}
                    />
                </NavLink>
            </div>
            <NavLink
                to={'/profile'}
                className={style.userName}
                draggable={false}
            >
                <div>{firstName}</div>
                <div>{lastName}</div>
            </NavLink>
            {hasOrganizations && (
                <div
                    className={style.organization}
                    onClick={onOrganizationClick}
                >
                    {isOpen ? organization : abbreviation}
                </div>
            )}
        </div>
    );
}
